var map = {
	"./A_0-4ABD-PL_1_530.png": "6ec1",
	"./A_4ABSD-48_1.png": "7e06",
	"./A_4AOU-58_3.png": "2742",
	"./Container.png": "8f3f",
	"./John_deere.png": "0bc1",
	"./Shovel.png": "9c0e",
	"./Track.png": "04a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5104";